import React from 'react';

interface Props {
    messages: string[]
}

const ExportWarningComponent: React.FC<Props> = ({messages}) => {

    return (
        <ul className='exports-warning'>
            {
                messages.length
                    ? <h2 className='exports-warning__title'>WARNINGS</h2>
                    : null
            }
            {
                messages.map((item) =>
                    <li key={item}>
                        <span> &rarr; </span>
                        { item }
                    </li>)
            }
        </ul>
    )
};

export default ExportWarningComponent